import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GanttViewIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "GanttView",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M15 7H5v3h10z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M15 11H5c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1M6 9h8V8H6zM27 15H13v3h14z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M27 19H13c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1m-13-2h12v-1H14zM19 23H5v3h14z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M19 27H5c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1M6 25h12v-1H6zM24 12c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1M24 30c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1s1 .45 1 1v7c0 .55-.45 1-1 1"
    })]
  }));
};